/* bios-designer-mode.js — [DESIGNERS] tab.

   Reads vendors from the rendered product items, dedupes them, paginates the
   resulting list 5-per-page in the same drum as products, and on click marks
   each product node in the right-hand netfield as a match/non-match so the
   designer's items "constellate" while everything else dims.

   Toggle UI:
     [NEW ARRIVALS]  [DESIGNERS]
   The non-active tab is faded; clicking it swaps modes (adds/removes
   .is-designer-mode on .bios-drum).                                         */
(function initDesignerMode() {
  'use strict';

  var drum         = document.getElementById('bios-drum');
  var tabProducts  = document.getElementById('bios-tab-products');
  var tabDesigners = document.getElementById('bios-tab-designers');
  var designerList = document.getElementById('bios-designer-list');
  var netfield     = document.getElementById('bios-netfield');
  if (!drum || !tabProducts || !tabDesigners || !designerList) return;

  /* Touch / coarse-pointer detection. On mobile the #bios-netfield is
     hidden via CSS, so the orbit ring + centered designer name (both
     pinned to viewport center) end up orphaned — the name floats with
     no constellation around it. Detecting touch here lets us bail out
     of those visual effects entirely and treat [DESIGNERS] as a clean
     directory/browse view on mobile. */
  var isTouchDevice = ('ontouchstart' in window) ||
    navigator.maxTouchPoints > 1 ||
    (window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches);

  /* ── Collect unique vendors from product items ── */
  var productItems = Array.prototype.slice.call(document.querySelectorAll('.bios-item'));
  var vendorMap = Object.create(null);
  productItems.forEach(function (item) {
    var v = (item.dataset.vendor || '').trim();
    if (!v) return;
    if (!vendorMap[v]) vendorMap[v] = [];
    vendorMap[v].push(item);
  });
  var vendors = Object.keys(vendorMap).sort(function (a, b) {
    return a.localeCompare(b);
  });

  /* ── Render the designer list (all rows; pagination handled by display:none).
     Mirrors the product-row column structure (addr + idx phantom spacers)
     so designer names align horizontally with the [DESIGNERS] label above. */
  vendors.forEach(function (name, idx) {
    var li = document.createElement('li');
    li.className = 'bios-designer-item';
    li.setAttribute('role', 'option');
    li.dataset.vendor = name;
    li.dataset.idx    = String(idx);
    var count = vendorMap[name].length;
    li.innerHTML =
      '<span class="bios-list-hdr-addr-sp" aria-hidden="true"></span>' +
      '<span class="bios-list-hdr-idx-sp"  aria-hidden="true"></span>' +
      '<div class="bios-designer-item-body">' +
        '<span class="bios-designer-item-label">' + name + '</span>' +
        '<span class="bios-designer-item-count">' + count + ' PIECE' + (count === 1 ? '' : 'S') + ' IN ARCHIVE</span>' +
      '</div>';
    designerList.appendChild(li);
  });

  var PAGE_SIZE = 4;
  var totalPages = Math.max(1, Math.ceil(vendors.length / PAGE_SIZE));
  var currentPage = 0;
  var allRows = Array.prototype.slice.call(designerList.querySelectorAll('.bios-designer-item'));

  function renderDesignerPage(page) {
    page = Math.max(0, Math.min(totalPages - 1, page));
    currentPage = page;
    var start = page * PAGE_SIZE;
    var end   = Math.min(start + PAGE_SIZE, allRows.length);
    allRows.forEach(function (row, i) {
      row.style.display = (i >= start && i < end) ? '' : 'none';
    });
  }
  renderDesignerPage(0);

  /* ── Filter the netfield to a selected vendor (no DOM removal — just class
     tagging so CSS can dim non-matches). */
  var _activeVendor = null;
  function applyDesignerNodeFilter(vendor) {
    if (!netfield) return;
    _activeVendor = vendor;
    if (!vendor) {
      netfield.classList.remove('is-designer-filter');
      netfield.querySelectorAll('.bios-netnode.is-designer-match').forEach(function (n) {
        n.classList.remove('is-designer-match');
      });
      return;
    }
    /* Each .bios-netnode has data-orig-idx — match against productItems[orig-idx]. */
    var nodes = netfield.querySelectorAll('.bios-netnode');
    nodes.forEach(function (node) {
      var origIdx = parseInt(node.dataset.origIdx || '-1', 10);
      var srcItem = origIdx >= 0 ? productItems[origIdx] : null;
      var match = srcItem && (srcItem.dataset.vendor || '').trim() === vendor;
      node.classList.toggle('is-designer-match', !!match);
    });
    netfield.classList.add('is-designer-filter');
  }

  /* ── Centered designer name overlay (created lazily) ── */
  var _centeredEl = null;
  function showCenteredName(label) {
    /* Skip on touch — the orbit ring around the name is invisible there
       (netfield is display:none on mobile), so the 30px name would
       float alone at viewport center. */
    if (isTouchDevice) return;
    if (!_centeredEl) {
      _centeredEl = document.createElement('div');
      _centeredEl.className = 'bios-designer-centered';
      _centeredEl.setAttribute('aria-hidden', 'true');
      document.body.appendChild(_centeredEl);
    }
    _centeredEl.textContent = label;
    /* Pin the name to the viewport center (so it visually aligns with the
       orbit, which we also center on viewport). */
    _centeredEl.style.left = (window.innerWidth / 2) + 'px';
    _centeredEl.style.top  = (window.innerHeight / 2) + 'px';
    /* Drive the fade-in directly from inline styles instead of relying on the
       class swap — Chromium sometimes drops the transition when the element
       is freshly attached to the DOM. Set start state, flush layout, then
       transition to visible. */
    _centeredEl.style.transition = 'none';
    _centeredEl.style.opacity    = '0';
    _centeredEl.style.transform  = 'translate(-50%, -50%) scale(0.85)';
    void _centeredEl.offsetWidth; /* flush */
    /* Synced to 0.7s with no delay so the name lands at the same moment
       the orbit nodes finish settling (orbit transitions are also 0.7s
       in applyDesignerOrbit). Previous 0.5s+0.15s-delay made the name
       pop in before the orbit completed, which felt disjointed. */
    _centeredEl.style.transition = 'opacity 0.7s ease, transform 0.7s cubic-bezier(0.4, 0, 0.2, 1)';
    _centeredEl.style.opacity    = '1';
    _centeredEl.style.transform  = 'translate(-50%, -50%) scale(1)';
    _centeredEl.classList.add('is-visible'); /* kept so CSS-only consumers still see the state */
  }
  function hideCenteredName() {
    if (!_centeredEl) return;
    _centeredEl.classList.remove('is-visible');
    _centeredEl.style.opacity = '0';
  }

  /* ── Orbit positioning: arrange matching nodes in a circle around netfield
     center. Sets style.left/top + transform directly. Works because the
     netgraph RAF loop pauses while #bios-netfield has .is-designer-orbit. */
  /* Track active orbit nodes + their base scale so hover magnification +
     orbit teardown can reach them cleanly. */
  var _orbitNodes = [];
  var _orbitBaseScale = 0.5;
  var _orbitMouseEnter = null;
  var _orbitMouseLeave = null;
  /* Pending setTimeouts from the chain-emerge animation. Tracked so
     exitDesignerOrbit() can cancel them if the user clicks away
     before the full ring has finished settling. */
  var _orbitTimeouts = [];
  function _clearOrbitTimeouts() {
    for (var t = 0; t < _orbitTimeouts.length; t++) clearTimeout(_orbitTimeouts[t]);
    _orbitTimeouts = [];
  }

  /* ── Orbit ALL netnodes (no designer selected yet). Tags every node
     as a match so the existing orbit positioning code picks them up,
     then runs through applyDesignerOrbit(). This is the entry-point
     view a user sees the moment they flip to [VIEW BY DESIGNER] —
     before any specific designer row has been clicked. */
  function applyAllItemsOrbit() {
    if (!netfield || isTouchDevice) return;
    var all = Array.prototype.slice.call(netfield.querySelectorAll('.bios-netnode'));
    all.forEach(function (n) { n.classList.add('is-designer-match'); });
    /* No specific vendor — pass null so the centred name stays hidden. */
    applyDesignerOrbit(null);
  }

  function applyDesignerOrbit(vendor) {
    if (!netfield) return;
    /* Bail on touch — netfield is display:none on mobile, so the orbit
       positions would be invisible work. The designer-name watcher and
       filtering are also no-ops in that state. */
    if (isTouchDevice) return;
    var matching = Array.prototype.slice.call(
      netfield.querySelectorAll('.bios-netnode.is-designer-match')
    );
    if (matching.length === 0) return;
    /* Orbit center: dead center of the viewport. The designer-UI (heading
       + brand list) also relocates to this point via CSS, so the orbit
       ring + the picker UI share the same focal point. Coordinates are
       expressed in netfield-local since orbit nodes are absolutely
       positioned inside netfield.

       Radius is pushed to fill the viewport — the only hard constraints
       are the header chrome at top and the manifest/footer strip at
       bottom. We use 42% of viewport height as the vertical limit
       (leaves ~8% margin to clear chrome) and 45% of viewport width as
       the horizontal limit. Smaller of the two wins so the ring stays
       a true circle. */
    var rect = netfield.getBoundingClientRect();
    var orbitCxView = window.innerWidth  * 0.50;
    var orbitCyView = window.innerHeight * 0.50;
    var localCx = orbitCxView - rect.left;
    var localCy = orbitCyView - rect.top;
    /* Bumped from 0.37 → 0.40 so the outer ring has slightly more
       circumference — gives each item more visual breathing room
       around the orbit. The chrome bars at top + bottom have soft
       gradient fades, so a small overlap at the extremes (ring
       bottom at y=900 on a 1000px viewport vs chrome top at y~888)
       reads as the orbit gently passing behind the chrome rather
       than a hard cutoff. horizLimit bumped 0.45 → 0.47 in parallel
       so wide viewports also benefit. */
    var vertLimit  = window.innerHeight * 0.38;
    var horizLimit = window.innerWidth  * 0.47;
    var maxRadius  = Math.min(vertLimit, horizLimit);
    var baseRadius = maxRadius * 0.88;
    var radius     = Math.min(maxRadius, baseRadius + Math.min(matching.length, 40) * 3.0);
    /* Node scale: smaller when more items so they don't overlap on the ring. */
    var scale = matching.length > 30 ? 0.26
              : matching.length > 15 ? 0.36
              : matching.length > 6  ? 0.48
              : 0.55;
    /* ── Chain-emerge animation ─────────────────────────────────────
       Instead of all items animating to their orbit positions at once,
       each item N emerges from item (N-1)'s orbit position with a
       per-item glitch flash on arrival. Item 0 emerges from the orbit
       centre. Visually reads as a "spark" tracing the ring, with each
       item materialising as the spark passes — much closer to the
       BIOS chain-reaction aesthetic than a synchronised pop. */
    _clearOrbitTimeouts();        /* cancel any prior chain still in flight */
    var STAGGER_MS = 70;
    var EMERGE_GLITCH_MS = 420;

    matching.forEach(function (node, i) {
      /* Snapshot pre-orbit position so exit can restore it. */
      if (node.dataset.origLeft == null) {
        node.dataset.origLeft = node.style.left || '';
        node.dataset.origTop  = node.style.top  || '';
      }
      var nodeSize = parseFloat(node.style.width) || 168;
      var halfNS   = nodeSize / 2;

      /* Final orbit position — clockwise from top. */
      var angle  = (i / matching.length) * 2 * Math.PI - Math.PI / 2;
      var orbitX = localCx + Math.cos(angle) * radius - halfNS;
      var orbitY = localCy + Math.sin(angle) * radius - halfNS;

      /* Start position: previous item's orbit slot (or centre for item 0). */
      var startX, startY;
      if (i === 0) {
        startX = localCx - halfNS;
        startY = localCy - halfNS;
      } else {
        var prevAngle = ((i - 1) / matching.length) * 2 * Math.PI - Math.PI / 2;
        startX = localCx + Math.cos(prevAngle) * radius - halfNS;
        startY = localCy + Math.sin(prevAngle) * radius - halfNS;
      }

      /* Step 1: place at start position invisibly with NO transition so
         the browser doesn't animate the teleport. */
      node.style.transition = 'none';
      node.style.display    = '';
      node.style.left       = startX + 'px';
      node.style.top        = startY + 'px';
      node.style.transform  = 'scale(' + (scale * 0.55) + ')';
      node.style.opacity    = '0';

      /* Step 2: after the stagger delay, kick off the smooth move
         (with transition restored) + the glitch class. */
      var delay = i * STAGGER_MS;
      var tId = setTimeout(function () {
        /* Force layout flush so the no-transition start state takes
           effect before the next style assignment animates. */
        void node.offsetWidth;
        node.style.transition =
          'left 0.45s cubic-bezier(0.4,0,0.2,1),' +
          'top 0.45s cubic-bezier(0.4,0,0.2,1),' +
          'transform 0.32s cubic-bezier(0.32,0.72,0,1),' +
          'opacity 0.30s ease';
        node.classList.add('is-orbit-emerging');
        node.style.left      = orbitX + 'px';
        node.style.top       = orbitY + 'px';
        node.style.transform = 'scale(' + scale + ')';
        node.style.opacity   = '1';
        var tId2 = setTimeout(function () {
          node.classList.remove('is-orbit-emerging');
        }, EMERGE_GLITCH_MS);
        _orbitTimeouts.push(tId2);
      }, delay);
      _orbitTimeouts.push(tId);
    });

    /* ── Hover magnification ─────────────────────────────────────────────
       When the user hovers a single orbit node, scale it up large and
       dim/shrink its siblings. Reads like a magnifying lens.
       The auto-open-on-dwell feature was removed: now the overlay
       opens only on an explicit click (netgraph's own click handler
       on the netnode), so hovering a node just previews it without
       committing the user into the product overlay. */
    _orbitNodes = matching;
    _orbitBaseScale = scale;
    var HOVER_UP    = 2.4;   /* hovered node — much larger preview */
    var HOVER_DOWN  = 0.55;  /* siblings shrink a bit more so the lens reads */

    function applyHoverScale(focusedNode) {
      _orbitNodes.forEach(function (n) {
        var mul = (n === focusedNode) ? HOVER_UP : HOVER_DOWN;
        n.style.transform = 'scale(' + (_orbitBaseScale * mul) + ')';
        n.style.zIndex    = (n === focusedNode) ? '6' : '4';
        n.style.opacity   = (n === focusedNode) ? '1'  : '0.45';
      });
    }
    function restoreScale() {
      _orbitNodes.forEach(function (n) {
        n.style.transform = 'scale(' + _orbitBaseScale + ')';
        n.style.zIndex    = '5';
        n.style.opacity   = '1';
      });
    }

    /* Detach any previous handlers (we may be re-orbiting a new designer). */
    if (_orbitMouseEnter) {
      _orbitNodes.forEach(function (n) {
        n.removeEventListener('mouseenter', _orbitMouseEnter);
        n.removeEventListener('mouseleave', _orbitMouseLeave);
      });
    }
    _orbitMouseEnter = function () { applyHoverScale(this); };
    _orbitMouseLeave = function () { restoreScale(); };
    matching.forEach(function (n) {
      n.addEventListener('mouseenter', _orbitMouseEnter);
      n.addEventListener('mouseleave', _orbitMouseLeave);
    });

    /* Pause the netgraph RAF loop so it doesn't override our positions. */
    netfield.classList.add('is-designer-orbit');
  }
  function exitDesignerOrbit() {
    if (!netfield) return;
    /* Cancel any pending chain-emerge timeouts so they don't fire
       after restoration — otherwise a half-completed orbit would
       race against the snapshot-restore below. */
    _clearOrbitTimeouts();
    /* Strip the in-flight glitch class from any node still mid-emerge. */
    netfield.querySelectorAll('.bios-netnode.is-orbit-emerging').forEach(function (n) {
      n.classList.remove('is-orbit-emerging');
    });
    netfield.classList.remove('is-designer-orbit');
    /* Detach hover handlers so they don't fire after orbit teardown. */
    if (_orbitMouseEnter) {
      _orbitNodes.forEach(function (n) {
        n.removeEventListener('mouseenter', _orbitMouseEnter);
        n.removeEventListener('mouseleave', _orbitMouseLeave);
      });
      _orbitMouseEnter = null;
      _orbitMouseLeave = null;
    }
    _orbitNodes = [];
    /* Restore each previously-orbited node back to the row-layout left/top
       that netgraph's layoutNodes() set at startup. netgraph doesn't
       re-apply positions on its own (no RAF for layout — positions are
       static), so we MUST restore from the snapshot we took on orbit-in.
       Clearing left/top to '' would collapse all nodes into the netfield
       corner, which is what was happening before this fix. */
    netfield.querySelectorAll('.bios-netnode').forEach(function (n) {
      if (n.dataset.origLeft != null) {
        n.style.left = n.dataset.origLeft;
        n.style.top  = n.dataset.origTop;
        delete n.dataset.origLeft;
        delete n.dataset.origTop;
      }
      n.style.transform  = '';
      n.style.transition = '';
      n.style.zIndex     = '';
      n.style.opacity    = '';
      n.style.display    = '';
    });
    hideCenteredName();
  }

  /* ── Row click — select designer, dim + orbit-arrange node graph ── */
  designerList.addEventListener('click', function (e) {
    var row = e.target.closest('.bios-designer-item');
    if (!row) return;
    var vendor = row.dataset.vendor;
    var wasActive = row.classList.contains('is-active');
    allRows.forEach(function (r) { r.classList.remove('is-active'); });
    if (wasActive) {
      /* Clicking the active row again returns to the all-items orbit
         (the entry view), so the user can browse other designers from
         that same orbiting constellation rather than reverting to a
         scattered netfield they then have to re-orbit from. */
      applyDesignerNodeFilter(null);
      exitDesignerOrbit();
      hideCenteredName();
      applyAllItemsOrbit();
      try { if (window.BiosAudio) window.BiosAudio.designerDisengage(); } catch (_) {}
    } else {
      row.classList.add('is-active');
      /* Tear down the prior orbit (all-items OR previous designer) so
         the new vendor's smaller ring can re-form cleanly. Without this
         the leftover orbit nodes from "all" would stay at their old
         positions while the new vendor's matching subset re-orbits. */
      exitDesignerOrbit();
      applyDesignerNodeFilter(vendor);
      applyDesignerOrbit(vendor);
      showCenteredName(vendor);
      try { if (window.BiosAudio) window.BiosAudio.designerEngage(); } catch (_) {}
    }
  });

  /* ── Stacked-label mode swap with glitch transition ── */
  var stackEl  = document.getElementById('bios-list-hdr-stack');
  var _flipBusy = false;
  function flipTo(designer) {
    if (_flipBusy) return;
    var alreadyThere = drum.classList.contains('is-designer-mode') === designer;
    if (alreadyThere) return;
    _flipBusy = true;
    /* Kick off the glitch class on the stack — animation lasts ~450ms. */
    if (stackEl) stackEl.classList.add('is-glitching');
    /* Audio sting on the swap — wide-band static burst at the start,
       low milestone tone at the mid-glitch frame. Reads as a hardware
       page change accompanying the visual fault. */
    try {
      if (window.BiosAudio) {
        window.BiosAudio.pageStaticBurst();
        setTimeout(function () { window.BiosAudio.bootTone(50); }, 180);
      }
    } catch (_) {}
    /* Mid-glitch (~180ms), swap active label and the drum mode so the
       content change looks synchronized with the visual fault. */
    setTimeout(function () {
      if (designer) {
        drum.classList.add('is-designer-mode');
        tabProducts.classList.remove('is-active');
        tabDesigners.classList.add('is-active');
        /* Show ALL items in the orbit immediately so the user sees the
           constellation as soon as they flip the tab — no need to click
           a designer first. Clicking a specific designer below replaces
           this with that vendor's filtered orbit. */
        applyAllItemsOrbit();
      } else {
        drum.classList.remove('is-designer-mode');
        tabDesigners.classList.remove('is-active');
        tabProducts.classList.add('is-active');
        applyDesignerNodeFilter(null);
        exitDesignerOrbit();
        allRows.forEach(function (r) { r.classList.remove('is-active'); });
      }
      /* Swap each tab's text between active label ("[NEW ARRIVALS]" /
         "[DESIGNERS]") and inactive prompt ("[VIEW NEW ARRIVALS]" /
         "[VIEW BY DESIGNER]") so the secondary always reads like an action. */
      [tabProducts, tabDesigners].forEach(function (tab) {
        var isActive = tab.classList.contains('is-active');
        var label = isActive ? tab.dataset.activeLabel : tab.dataset.inactiveLabel;
        if (label) tab.textContent = label;
      });
    }, 180);
    setTimeout(function () {
      if (stackEl) stackEl.classList.remove('is-glitching');
      _flipBusy = false;
    }, 470);
  }

  /* Click the inactive label (the small grey one) to swap. Clicking the
     active label is a no-op (cursor:default styled too). */
  tabDesigners.addEventListener('click', function (e) {
    e.stopPropagation();
    flipTo(true);
  });
  tabProducts.addEventListener('click', function (e) {
    e.stopPropagation();
    flipTo(false);
  });

  /* ── Wheel-page transitions inside designer mode ── */
  drum.addEventListener('wheel', function (e) {
    if (!drum.classList.contains('is-designer-mode')) return;
    e.preventDefault();
    var dir = e.deltaY > 0 ? 1 : -1;
    var next = currentPage + dir;
    if (next < 0 || next >= totalPages) return;
    renderDesignerPage(next);
  }, { passive: false });

  /* ── Expose for keyboard nav / future hooks ── */
  window._biosDesignerNext = function () { renderDesignerPage(currentPage + 1); };
  window._biosDesignerPrev = function () { renderDesignerPage(currentPage - 1); };

  /* ── Hide the centered designer name while either the product overlay
        OR the low-power idle screen is open — both render full-screen
        content that the centered name would sit on top of. We watch a
        class on each element via MutationObserver and toggle a single
        "should be hidden" flag from either source. ── */
  (function watchObscurers() {
    if (typeof MutationObserver === 'undefined') return;
    /* IDs must match the actual DOM — main-content.liquid uses #bios-overlay
       (was previously typed as 'bios-ov' here, so the observer silently
       no-op'd and the designer name stayed visible behind the product
       popup). */
    var overlayEl  = document.getElementById('bios-overlay');
    var lowpowerEl = document.getElementById('bios-lowpower');

    var sources = {
      overlay:  false, /* overlay open */
      lowpower: false  /* idle screen active */
    };
    var wasShownBeforeAnyHid = false;

    function syncVisibility() {
      if (!_centeredEl) return;
      var anyObscurer = sources.overlay || sources.lowpower;
      if (anyObscurer) {
        /* If nothing was hiding the name yet, remember whether it was
           visible so we know whether to restore on the way back. */
        if (!wasShownBeforeAnyHid) {
          wasShownBeforeAnyHid = _centeredEl.classList.contains('is-visible');
        }
        if (wasShownBeforeAnyHid) {
          _centeredEl.style.transition = 'opacity 0.18s ease, transform 0.18s ease';
          _centeredEl.style.opacity    = '0';
          _centeredEl.style.transform  = 'translate(-50%, -50%) scale(0.92)';
        }
      } else if (wasShownBeforeAnyHid) {
        _centeredEl.style.transition = 'opacity 0.32s ease 0.10s, transform 0.32s ease 0.10s';
        _centeredEl.style.opacity    = '1';
        _centeredEl.style.transform  = 'translate(-50%, -50%) scale(1)';
        wasShownBeforeAnyHid = false;
      }
    }

    if (overlayEl) {
      new MutationObserver(function () {
        sources.overlay = overlayEl.classList.contains('is-open');
        syncVisibility();
      }).observe(overlayEl, { attributes: true, attributeFilter: ['class'] });
    }
    if (lowpowerEl) {
      new MutationObserver(function () {
        sources.lowpower = lowpowerEl.classList.contains('is-active');
        syncVisibility();
      }).observe(lowpowerEl, { attributes: true, attributeFilter: ['class'] });
    }
  })();

  /* ── Catalog orbit mode ─────────────────────────────────────────────
     [NEW ARRIVALS] view: orbit ALL items around the centered batch list
     by default. Newest BATCH_SIZE items get .is-batch-item, shown in
     the center stack; the full archive surrounds them in the ring.
     Hovering a batch title in the center list shows that item's image
     on a fixed-position preview pane at the right edge.

     We piggyback on the same applyAllItemsOrbit / orbit positioning
     logic that designer mode uses — it's already debugged and respects
     touch / reduced motion. Difference is purely which CSS class is on
     the drum (.is-catalog-orbit-mode vs .is-designer-mode), driving
     different center-UI styling. */
  /* Reduced 12 → 8: the centered list was overflowing the inner ring
     when long product titles wrapped to two lines. 8 items at 16px /
     1.3 line-height fits comfortably inside the inner-ring diameter
     (~462px on 1080p) and the 8-item inner ring reads as a cleaner
     compass-point pattern (45° apart) than 12 packed at 30° apart.
     Total pages for 50 products: ceil(50/8) = 7 pages. */
  var BATCH_SIZE = 8;
  var _catalogOrbitInited = false;
  /* Current batch page (0-indexed). Each page maps to a contiguous
     window of BATCH_SIZE items in the .bios-item list (sorted
     newest-first by Liquid). Updated by setBatchPage() in response
     to wheel scroll inside the orbit. */
  var _currentBatchPage = 0;

  /* Detect a leading vendor prefix in the product title and wrap it
     in a span with the dim class. Case-insensitive match — handles
     "5351 POUR LES HOMMES BLACK CARGO PANTS" where the vendor
     "5351 POUR LES HOMMES" prefixes the title. Returns an HTML
     string ready to assign via innerHTML. If there's no match,
     returns the title escaped as plain text (safe to drop into
     innerHTML). Exposed on window so bios-main.js can use it too
     for the product overlay's featured title + related list. */
  function _escHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
  function dimVendorPrefix(title, vendor) {
    if (!title) return '';
    if (!vendor) return _escHtml(title);
    /* Normalise whitespace before comparing — Shopify can occasionally
       emit double-spaces or trailing whitespace in the vendor field. */
    var v = String(vendor).replace(/\s+/g, ' ').trim();
    if (!v) return _escHtml(title);
    var t = String(title);
    if (t.toUpperCase().indexOf(v.toUpperCase()) !== 0) {
      return _escHtml(t);
    }
    /* Title starts with vendor (case-insensitive) — split into vendor
       portion + remainder, wrap vendor in dim span. Both halves are
       escaped so any &, <, > etc. in the original title don't break
       the HTML. */
    var vendorPart = t.substring(0, v.length);
    var rest       = t.substring(v.length);
    return '<span class="bios-vendor-prefix">' + _escHtml(vendorPart) + '</span>' + _escHtml(rest);
  }
  window._biosDimVendorPrefix = dimVendorPrefix;

  /* Set which items + netnodes carry .is-batch-item for the given
     page. Page p covers items [p*BATCH_SIZE, (p+1)*BATCH_SIZE).
     Idempotent — calling with the same page is a no-op. Returns
     true if any class actually changed (so callers can skip the
     re-emerge work when nothing changes).

     Also force-populates the .bios-item-name text from data-name
     for every batch item — without this, items that were never
     reached by the staggered initial typewriter (or that had their
     text cleared by an interrupted hover) would render with empty
     titles after pagination. The centred list is the user's only
     way to read product names, so it MUST always show the right
     text for the current batch, regardless of typewriter state. */
  function tagBatchForPage(pageNum) {
    if (!netfield || !drum) return false;
    var items = document.querySelectorAll('#bios-list .bios-item');
    if (!items.length) return false;
    var total = items.length;
    var totalPages = Math.max(1, Math.ceil(total / BATCH_SIZE));
    pageNum = Math.max(0, Math.min(totalPages - 1, pageNum));
    var startIdx = pageNum * BATCH_SIZE;
    var endIdx   = Math.min(startIdx + BATCH_SIZE, total);
    var changed = false;

    for (var i = 0; i < items.length; i++) {
      var shouldBeBatch = (i >= startIdx && i < endIdx);
      if (items[i].classList.contains('is-batch-item') !== shouldBeBatch) {
        items[i].classList.toggle('is-batch-item', shouldBeBatch);
        changed = true;
      }
      /* CRITICAL: clear any inline style.display on EVERY item.
         At page load, bios-main.js's renderPage(0) runs with
         PAGE_SIZE=4 and writes `item.style.display='none'` inline
         on items 4..N-1. That inline style outranks every cascade
         CSS rule (including `:not(.is-batch-item){display:none}`
         and any !important rule below class-pinned inline styles).
         Without clearing it, items 12..23 stay invisible after
         pagination even when they get the .is-batch-item class —
         which is the "no titles on next page" bug. Clearing the
         inline display lets the cascade rules take over:
           .bios-item:not(.is-batch-item) {display:none} — hides
                                                          non-batch
           .bios-item {display:flex} (default)          — shows batch */
      items[i].style.display = '';

      /* For items becoming visible in the new batch: cancel any
         lingering typewriter state and force the full title text.
         Also reset data-dist=0 so other rules (price color, addr
         color, etc) treat the row as the "active" focal row. */
      if (shouldBeBatch) {
        var nameEl = items[i].querySelector('.bios-item-name');
        var fullName = items[i].dataset.name || '';
        var vendorName = items[i].dataset.vendor || '';
        var dimmedHtml = dimVendorPrefix(fullName, vendorName);
        /* Compare against textContent (browser strips HTML for us) so
           we don't churn innerHTML on every page change. */
        if (nameEl && (nameEl.textContent !== fullName || nameEl.classList.contains('is-typing'))) {
          nameEl.classList.remove('is-typing');
          nameEl.classList.remove('is-error');
          nameEl.classList.remove('is-scroll-revealing');
          nameEl.classList.remove('is-glitching');
          /* innerHTML — dimmedHtml is already escaped + wraps the
             vendor portion in <span class="bios-vendor-prefix">. */
          nameEl.innerHTML = dimmedHtml;
        }
        items[i].dataset.dist = '0';
        items[i].classList.add('is-loaded');
        /* Defensive: also clear any inline opacity if set. */
        items[i].style.opacity = '';
      }
    }
    var nodes = netfield.querySelectorAll('.bios-netnode');
    nodes.forEach(function (n) {
      var origIdx = parseInt(n.dataset.origIdx, 10);
      if (isNaN(origIdx)) return;
      var shouldBeBatch = (origIdx >= startIdx && origIdx < endIdx);
      if (n.classList.contains('is-batch-item') !== shouldBeBatch) {
        n.classList.toggle('is-batch-item', shouldBeBatch);
        changed = true;
      }
    });
    return changed;
  }

  /* Back-compat: initial setup calls this name, which defaults to page 0. */
  function tagBatchItemsAndNodes() {
    tagBatchForPage(_currentBatchPage);
  }

  /* Catalog-mode orbit: positions ALL netnodes in two concentric rings.
       outer ring — non-batch items (rest of the archive)
       inner ring — the BATCH_SIZE batch items, offset color for emphasis
     The two rings form a "you are here" composition: the batch is
     visually clustered near the centered title list, with the broader
     archive surrounding it at a larger radius. Item scale shrinks for
     dense rings (many archive items at the outer radius). */
  function applyCatalogOrbit() {
    if (!netfield || isTouchDevice) return;
    /* Ring-loading SFX — fires once at the start of the cascade emerge
       (when EXPERIENCE is clicked + portal dismisses, OR when the user
       toggles back to NEW ARRIVALS from DESIGNERS mode). undo.wav
       reused here so the "system is loading the constellation" beat
       has its own signature. Vol 0.30, slightly above the 0.20
       keystroke since this is a once-per-session big moment.
       transitionCatalogOrbit (smooth slide on page-change) doesn't
       fire this — that has its own swap.wav. */
    try {
      var _ringSfx = new Audio('https://cdn.shopify.com/s/files/1/0762/5726/3866/files/undo.wav?v=1779655474');
      _ringSfx.volume = 0.30;
      var _rsp = _ringSfx.play();
      if (_rsp && typeof _rsp.catch === 'function') _rsp.catch(function () {});
    } catch (_) {}
    var rect = netfield.getBoundingClientRect();
    var orbitCxView = window.innerWidth  * 0.50;
    /* NEW-ARRIVALS vertical anchor shifted from 50vh → 44vh so the
       orbit composition (centred title list + ring + preview) sits
       higher in the viewport. The previous 50vh centred the ring on
       the geometric centre, which left a heavy bottom half balanced
       against header chrome above. Lifting to 44vh gives the cluster
       more breathing room below for the manifest bar + footer
       actions without crowding the chrome at top. */
    var orbitCyView = window.innerHeight * 0.48;
    var localCx = orbitCxView - rect.left;
    var localCy = orbitCyView - rect.top;
    /* Bumped from 0.37 → 0.40 so the outer ring has slightly more
       circumference — gives each item more visual breathing room
       around the orbit. The chrome bars at top + bottom have soft
       gradient fades, so a small overlap at the extremes (ring
       bottom at y=900 on a 1000px viewport vs chrome top at y~888)
       reads as the orbit gently passing behind the chrome rather
       than a hard cutoff. horizLimit bumped 0.45 → 0.47 in parallel
       so wide viewports also benefit. */
    /* Viewport-aware ring sizing. Computes the largest radius that fits
       BETWEEN the header chrome (top) and the manifest/footer chrome
       (bottom) given the actual orbit centre, then derives the inner
       ring as a proportion of the outer with a guaranteed MIN_GAP
       between them. Prevents two failure modes on smaller displays:
         1. Outer ring clipping into the header or footer chrome
         2. Inner + outer cramming together (when the old MAX(maxR*0.62, 180)
            floor forced inner up to 180 while outer stayed at e.g. 220) */
    var HEADER_PX = 50;   /* approx chrome height at top of viewport */
    var FOOTER_PX = 100;  /* manifest bar + footer actions row */
    var MIN_GAP   = 90;   /* minimum spacing between inner and outer rings */
    var MIN_INNER = 120;  /* floor so titles + 8 batch items fit comfortably */
    var safeUp     = orbitCyView - HEADER_PX;
    var safeDown   = window.innerHeight - orbitCyView - FOOTER_PX;
    var vertLimit  = Math.min(safeUp, safeDown);
    var horizLimit = window.innerWidth * 0.47;
    var maxRadius  = Math.min(vertLimit, horizLimit);
    var outerRadius = maxRadius;
    /* Inner = 62% of outer (visual ratio that reads as "concentric"),
       BUT clamped so outer - inner ≥ MIN_GAP. On small viewports the
       proportion would push them too close, so the gap clamp wins. */
    var innerRadius = Math.min(outerRadius * 0.62, outerRadius - MIN_GAP);
    innerRadius = Math.max(innerRadius, MIN_INNER);

    /* Tag netfield as in orbit so the netgraph RAF + sold-out flicker
       both bail and let us own opacity/transform. */
    netfield.classList.add('is-designer-orbit');

    /* Tag all nodes is-designer-match so any other orbit code that
       filters by that class still sees the full set. */
    var allNodes = Array.prototype.slice.call(netfield.querySelectorAll('.bios-netnode'));
    allNodes.forEach(function (n) { n.classList.add('is-designer-match'); });

    var batchNodes = allNodes.filter(function (n) { return n.classList.contains('is-batch-item'); });
    var restNodes  = allNodes.filter(function (n) { return !n.classList.contains('is-batch-item'); });

    _clearOrbitTimeouts();
    var STAGGER_MS = 55;

    function emergeOnRing(nodes, radius, scale, startAngle, delayOffset, ringName) {
      var nCount = nodes.length;
      if (nCount === 0) return;
      nodes.forEach(function (node, i) {
        if (node.dataset.origLeft == null) {
          node.dataset.origLeft = node.style.left || '';
          node.dataset.origTop  = node.style.top  || '';
        }
        var nodeSize = parseFloat(node.style.width) || 168;
        var halfNS   = nodeSize / 2;
        var angle    = (i / nCount) * 2 * Math.PI - Math.PI / 2 + (startAngle || 0);
        var orbitX   = localCx + Math.cos(angle) * radius - halfNS;
        var orbitY   = localCy + Math.sin(angle) * radius - halfNS;
        node.style.transition = 'none';
        node.style.display    = '';
        node.style.left       = orbitX + 'px';
        node.style.top        = orbitY + 'px';
        node.style.transform  = 'scale(' + (scale * 0.6) + ')';
        node.style.opacity    = '0';
        var delay = (delayOffset || 0) + i * STAGGER_MS;
        var tId = setTimeout(function () {
          void node.offsetWidth;
          node.style.transition =
            'left 0.5s cubic-bezier(0.4,0,0.2,1),' +
            'top 0.5s cubic-bezier(0.4,0,0.2,1),' +
            'transform 0.35s cubic-bezier(0.32,0.72,0,1),' +
            'opacity 0.30s ease';
          node.classList.add('is-orbit-emerging');
          node.style.transform = 'scale(' + scale + ')';
          node.style.opacity   = '1';
          /* Mark ring membership so transitionCatalogOrbit() can detect
             ring-swap nodes on subsequent page changes. */
          if (ringName) node.dataset.orbitRing = ringName;
          var tId2 = setTimeout(function () {
            node.classList.remove('is-orbit-emerging');
          }, 420);
          _orbitTimeouts.push(tId2);
        }, delay);
        _orbitTimeouts.push(tId);
      });
    }

    /* ── Two-tier outer-ring system (middle + halo) ──────────────────
       Catalog grows past the visual capacity of a single ring (>~24
       items pack too tightly). Solution: cap the OPAQUE middle ring
       at MIDDLE_CAP items and put the remainder in a transparent
       outermost "halo" ring at a larger radius + smaller scale +
       low opacity. The halo reads as atmospheric depth — it
       signals "there's more in the catalog" without competing with
       the active middle/inner content. On pagination, halo items
       feed inward into the middle ring as the rotation progresses
       (handled naturally by the existing slide-to-ring in
       transitionCatalogOrbit since both groups re-sort + re-emerge). */
    var MIDDLE_CAP        = 24;    /* max items in the opaque middle ring */
    var HALO_RADIUS_MULT  = 1.28;  /* halo radius = middle radius * 1.28 */
    var HALO_SCALE_MULT   = 0.55;  /* halo items are 55% of middle scale */
    restNodes.sort(function (a, b) {
      return (parseInt(a.dataset.origIdx, 10) || 0) - (parseInt(b.dataset.origIdx, 10) || 0);
    });
    var middleNodes = restNodes.slice(0, MIDDLE_CAP);
    var haloNodes   = restNodes.slice(MIDDLE_CAP);
    /* Clear stale halo class on items that may have been in halo on a
       previous render but are now in middle (or vice versa). */
    restNodes.forEach(function (n) { n.classList.remove('is-halo'); });
    haloNodes.forEach(function (n) { n.classList.add('is-halo'); });

    var restScale = middleNodes.length > 20 ? 0.34
                  : middleNodes.length > 15 ? 0.38
                  : middleNodes.length > 6  ? 0.50
                  : 0.56;
    emergeOnRing(middleNodes, outerRadius, restScale, 0, 0, 'outer');
    if (haloNodes.length > 0) {
      emergeOnRing(haloNodes, outerRadius * HALO_RADIUS_MULT, restScale * HALO_SCALE_MULT, 0, 0, 'halo');
    }

    /* Inner ring — batch items. Larger scale since fewer items and they
       sit on a tighter circle. Small angular offset so they don't
       perfectly stack with outer-ring items at the same angles. */
    batchNodes.sort(function (a, b) {
      return (parseInt(a.dataset.origIdx, 10) || 0) - (parseInt(b.dataset.origIdx, 10) || 0);
    });
    var batchScale = batchNodes.length > 8 ? 0.34 : 0.42;
    var batchStartAngle = Math.PI / batchNodes.length;
    emergeOnRing(batchNodes, innerRadius, batchScale, batchStartAngle, restNodes.length * STAGGER_MS * 0.3, 'inner');
  }

  /* Smooth-transition version of applyCatalogOrbit used on page change.
     Unlike applyCatalogOrbit (which resets transitions + opacity to 0
     and chain-emerges every node), this just writes new left/top/scale
     and lets the existing CSS transition smoothly slide items between
     their old and new positions. Items that stay on the same ring
     barely move (their angular position depends only on their origIdx
     and the count of items in their ring); items swapping rings glide
     from inner→outer or outer→inner.

     Each node gets a small per-index stagger (40ms) so the transition
     reads as a wave around the ring rather than every node jumping at
     once. Items being SWAPPED IN to a different ring also get a brief
     opacity dip mid-flight so the crossfade reads as a deliberate
     swap, not a teleport. */
  function transitionCatalogOrbit() {
    if (!netfield || isTouchDevice) return;
    var rect = netfield.getBoundingClientRect();
    var orbitCxView = window.innerWidth  * 0.50;
    /* Mirror applyCatalogOrbit's 44vh anchor so page-change transitions
       slide between the same vertical centre — otherwise paginating
       between batches would visibly drop the whole composition back to
       50vh, breaking the lifted layout. */
    var orbitCyView = window.innerHeight * 0.48;
    var localCx = orbitCxView - rect.left;
    var localCy = orbitCyView - rect.top;
    /* Bumped from 0.37 → 0.40 so the outer ring has slightly more
       circumference — gives each item more visual breathing room
       around the orbit. The chrome bars at top + bottom have soft
       gradient fades, so a small overlap at the extremes (ring
       bottom at y=900 on a 1000px viewport vs chrome top at y~888)
       reads as the orbit gently passing behind the chrome rather
       than a hard cutoff. horizLimit bumped 0.45 → 0.47 in parallel
       so wide viewports also benefit. */
    /* Viewport-aware ring sizing. Computes the largest radius that fits
       BETWEEN the header chrome (top) and the manifest/footer chrome
       (bottom) given the actual orbit centre, then derives the inner
       ring as a proportion of the outer with a guaranteed MIN_GAP
       between them. Prevents two failure modes on smaller displays:
         1. Outer ring clipping into the header or footer chrome
         2. Inner + outer cramming together (when the old MAX(maxR*0.62, 180)
            floor forced inner up to 180 while outer stayed at e.g. 220) */
    var HEADER_PX = 50;   /* approx chrome height at top of viewport */
    var FOOTER_PX = 100;  /* manifest bar + footer actions row */
    var MIN_GAP   = 90;   /* minimum spacing between inner and outer rings */
    var MIN_INNER = 120;  /* floor so titles + 8 batch items fit comfortably */
    var safeUp     = orbitCyView - HEADER_PX;
    var safeDown   = window.innerHeight - orbitCyView - FOOTER_PX;
    var vertLimit  = Math.min(safeUp, safeDown);
    var horizLimit = window.innerWidth * 0.47;
    var maxRadius  = Math.min(vertLimit, horizLimit);
    var outerRadius = maxRadius;
    /* Inner = 62% of outer (visual ratio that reads as "concentric"),
       BUT clamped so outer - inner ≥ MIN_GAP. On small viewports the
       proportion would push them too close, so the gap clamp wins. */
    var innerRadius = Math.min(outerRadius * 0.62, outerRadius - MIN_GAP);
    innerRadius = Math.max(innerRadius, MIN_INNER);

    _clearOrbitTimeouts();

    var allNodes  = Array.prototype.slice.call(netfield.querySelectorAll('.bios-netnode'));
    var batchNodes = allNodes.filter(function (n) { return n.classList.contains('is-batch-item'); });
    var restNodes  = allNodes.filter(function (n) { return !n.classList.contains('is-batch-item'); });

    /* Same deterministic sort as applyCatalogOrbit — so unchanged items
       on either ring land in the same slot they were in before. */
    restNodes.sort(function (a, b) {
      return (parseInt(a.dataset.origIdx, 10) || 0) - (parseInt(b.dataset.origIdx, 10) || 0);
    });
    batchNodes.sort(function (a, b) {
      return (parseInt(a.dataset.origIdx, 10) || 0) - (parseInt(b.dataset.origIdx, 10) || 0);
    });

    /* Same scale bump as applyCatalogOrbit so the sliding transition
       lands items at the larger size. */
    var restScale  = restNodes.length > 30 ? 0.30
                   : restNodes.length > 15 ? 0.38
                   : restNodes.length > 6  ? 0.50
                   : 0.56;
    var batchScale = batchNodes.length > 8 ? 0.34 : 0.42;
    var batchStartAngle = Math.PI / Math.max(batchNodes.length, 1);

    /* Track each node's previous ring so we can detect ring-swaps and
       give those nodes a brief mid-flight opacity dip. Stored as a
       dataset attribute so it survives between calls. */
    function slideToRing(nodes, radius, scale, startAngle, expectedRing) {
      var nCount = nodes.length;
      if (nCount === 0) return;
      var STAGGER_MS = 40;
      nodes.forEach(function (node, i) {
        var nodeSize = parseFloat(node.style.width) || 168;
        var halfNS   = nodeSize / 2;
        var angle    = (i / nCount) * 2 * Math.PI - Math.PI / 2 + (startAngle || 0);
        var orbitX   = localCx + Math.cos(angle) * radius - halfNS;
        var orbitY   = localCy + Math.sin(angle) * radius - halfNS;
        var prevRing = node.dataset.orbitRing || '';
        var ringSwap = (prevRing && prevRing !== expectedRing);
        var delay    = i * STAGGER_MS;
        var tId = setTimeout(function () {
          node.style.transition =
            'left 0.6s cubic-bezier(0.4,0,0.2,1),' +
            'top 0.6s cubic-bezier(0.4,0,0.2,1),' +
            'transform 0.45s cubic-bezier(0.32,0.72,0,1),' +
            'opacity 0.35s ease';
          node.style.display   = '';
          node.style.left      = orbitX + 'px';
          node.style.top       = orbitY + 'px';
          node.style.transform = 'scale(' + scale + ')';
          /* Ring-swap items: dip to 0.35 briefly, then snap back —
             reads as a "blip" of corruption as the node crosses the
             gap between rings. Items staying on the same ring just
             slide to their new slot at full opacity. */
          if (ringSwap) {
            node.style.opacity = '0.35';
            var tId2 = setTimeout(function () {
              node.style.opacity = '1';
            }, 200);
            _orbitTimeouts.push(tId2);
          } else {
            node.style.opacity = '1';
          }
          node.dataset.orbitRing = expectedRing;
        }, delay);
        _orbitTimeouts.push(tId);
      });
    }
    /* Same MIDDLE_CAP split as applyCatalogOrbit so paginated slides
       move items between middle and halo correctly. Items crossing the
       middle↔halo boundary read as "feeding in" / "fading out" of the
       atmospheric layer thanks to the ring-swap opacity dip in
       slideToRing. */
    var MIDDLE_CAP        = 24;
    var HALO_RADIUS_MULT  = 1.28;
    var HALO_SCALE_MULT   = 0.55;
    var middleNodes = restNodes.slice(0, MIDDLE_CAP);
    var haloNodes   = restNodes.slice(MIDDLE_CAP);
    restNodes.forEach(function (n) { n.classList.remove('is-halo'); });
    haloNodes.forEach(function (n) { n.classList.add('is-halo'); });

    slideToRing(middleNodes, outerRadius, restScale, 0, 'outer');
    if (haloNodes.length > 0) {
      slideToRing(haloNodes, outerRadius * HALO_RADIUS_MULT, restScale * HALO_SCALE_MULT, 0, 'halo');
    }
    slideToRing(batchNodes, innerRadius, batchScale, batchStartAngle, 'inner');
  }

  /* ── Per-item idle drift ───────────────────────────────────────────
     While catalog-orbit is active, each non-batch (outer-ring) node
     oscillates by a tiny amount around its base position so the
     constellation reads as "alive" instead of rigid. The drift is
     added on top of the node's static orbit position via a per-frame
     transform tweak — does NOT touch left/top so it doesn't fight
     the pagination slide or the chain-emerge math.

     Each node gets a randomized frequency + phase so they don't
     pulse in sync. Amplitude is small (~3px) and slow (~12-18s
     period) so the eye reads it as breathing/floating, not motion.
     Inner-ring batch nodes are excluded — they sit near the centred
     list and any drift there would feel jittery. */
  var _idleDriftRaf = null;
  var _idleDriftActive = false;

  function startIdleDrift() {
    if (_idleDriftActive) return;
    if (isTouchDevice) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    _idleDriftActive = true;
    var t0 = performance.now();
    (function tick(now) {
      if (!_idleDriftActive) return;
      if (!drum || !drum.classList.contains('is-catalog-orbit-mode')) {
        _idleDriftActive = false; _idleDriftRaf = null; return;
      }
      var t = (now - t0) * 0.001;   /* seconds */
      var allNodes = netfield.querySelectorAll('.bios-netnode');
      for (var i = 0; i < allNodes.length; i++) {
        var n = allNodes[i];
        /* Skip the currently-spinning state (handled by spin RAF). */
        if (_spinning) continue;
        /* Both inner (batch) and outer (archive) nodes drift now —
           gives the whole orbit a "live" breathing feel. Inner-ring
           items get tighter amplitude so the focal centre list
           isn't visually destabilised. */
        var isBatch = n.classList.contains('is-batch-item');
        /* Skip nodes we haven't seeded yet — assign per-node random
           drift params lazily. Slowed down to ~25-40s period (was
           12-18s) so the motion reads as "atmospheric" rather than
           "scanning rapidly". Amplitude unchanged for outer ring,
           halved for inner ring so the smaller orbit stays calm. */
        if (n.dataset._driftFreq == null) {
          n.dataset._driftFreq  = (0.025 + Math.random() * 0.025).toFixed(4); /* ~25-40s period */
          n.dataset._driftPhase = (Math.random() * Math.PI * 2).toFixed(3);
          if (isBatch) {
            /* Inner ring: tighter ±0.7-1.5px so it doesn't jitter
               the focal centre list area. */
            n.dataset._driftAmpX = (0.7 + Math.random() * 0.8).toFixed(2);
            n.dataset._driftAmpY = (0.6 + Math.random() * 0.7).toFixed(2);
          } else {
            /* Outer ring: a bit more breathing room. */
            n.dataset._driftAmpX = (1.2 + Math.random() * 2.4).toFixed(2);
            n.dataset._driftAmpY = (1.0 + Math.random() * 2.0).toFixed(2);
          }
        }
        var freq  = parseFloat(n.dataset._driftFreq);
        var phase = parseFloat(n.dataset._driftPhase);
        var ampX  = parseFloat(n.dataset._driftAmpX);
        var ampY  = parseFloat(n.dataset._driftAmpY);
        var dx = Math.sin(t * freq * Math.PI * 2 + phase) * ampX;
        var dy = Math.cos(t * freq * Math.PI * 2 + phase * 1.3) * ampY;
        /* Compose with the node's existing static `transform: scale(s)`
           so we don't clobber it. The base scale is in --orbit-scale
           if set, otherwise parse from style.transform. Simplest path:
           preserve the trailing scale() and prepend a translate3d. */
        var baseTransform = n.dataset._driftBaseTransform;
        if (baseTransform == null) {
          baseTransform = (n.style.transform || '').replace(/translate3d\([^)]*\)\s*/g, '');
          n.dataset._driftBaseTransform = baseTransform;
        }
        n.style.transform = 'translate3d(' + dx.toFixed(2) + 'px,' + dy.toFixed(2) + 'px,0) ' + baseTransform;
      }
      _idleDriftRaf = requestAnimationFrame(tick);
    })(performance.now());
  }

  function stopIdleDrift() {
    _idleDriftActive = false;
    if (_idleDriftRaf) {
      cancelAnimationFrame(_idleDriftRaf);
      _idleDriftRaf = null;
    }
    /* Clear cached base transforms so the next orbit re-emerge can
       repopulate them from fresh state. */
    if (netfield) {
      netfield.querySelectorAll('.bios-netnode').forEach(function (n) {
        delete n.dataset._driftBaseTransform;
      });
    }
  }

  /* ── Ambient counter-rotation idle spin ──────────────────────────────
     Every 18–48 seconds while catalog-orbit is active, kick both rings
     into a short rotation: inner spins one direction, outer the
     opposite, slightly slower. Random per-call direction sign so it
     doesn't always go the same way. Duration ~6–8s, ease-in-out cubic
     so it accelerates from rest and settles back into the static
     constellation cleanly. Only touches left/top — opacity / scale /
     flicker / sold-out corruption all keep running on their own
     animations during the spin. */
  var _spinning = false;
  var _spinRafId = null;
  var _spinTimeout = null;

  function cancelSpin() {
    if (_spinRafId) {
      cancelAnimationFrame(_spinRafId);
      _spinRafId = null;
    }
    if (_spinning) {
      /* Restore any saved transitions on nodes we paused mid-spin. */
      var allNodes = netfield.querySelectorAll('.bios-netnode');
      allNodes.forEach(function (n) {
        if (n.dataset._spinOrigTrans != null) {
          n.style.transition = n.dataset._spinOrigTrans;
          delete n.dataset._spinOrigTrans;
        }
      });
      _spinning = false;
    }
  }

  function spinOnce() {
    if (_spinning) return;
    if (!drum || !drum.classList.contains('is-catalog-orbit-mode')) return;
    if (isTouchDevice || !netfield) return;

    var rect = netfield.getBoundingClientRect();
    var orbitCxView = window.innerWidth  * 0.50;
    /* 44vh — matches applyCatalogOrbit / transitionCatalogOrbit so the
       idle counter-rotation spin orbits around the same lifted centre. */
    var orbitCyView = window.innerHeight * 0.48;
    var localCx = orbitCxView - rect.left;
    var localCy = orbitCyView - rect.top;
    /* Bumped from 0.37 → 0.40 so the outer ring has slightly more
       circumference — gives each item more visual breathing room
       around the orbit. The chrome bars at top + bottom have soft
       gradient fades, so a small overlap at the extremes (ring
       bottom at y=900 on a 1000px viewport vs chrome top at y~888)
       reads as the orbit gently passing behind the chrome rather
       than a hard cutoff. horizLimit bumped 0.45 → 0.47 in parallel
       so wide viewports also benefit. */
    /* Viewport-aware ring sizing. Computes the largest radius that fits
       BETWEEN the header chrome (top) and the manifest/footer chrome
       (bottom) given the actual orbit centre, then derives the inner
       ring as a proportion of the outer with a guaranteed MIN_GAP
       between them. Prevents two failure modes on smaller displays:
         1. Outer ring clipping into the header or footer chrome
         2. Inner + outer cramming together (when the old MAX(maxR*0.62, 180)
            floor forced inner up to 180 while outer stayed at e.g. 220) */
    var HEADER_PX = 50;   /* approx chrome height at top of viewport */
    var FOOTER_PX = 100;  /* manifest bar + footer actions row */
    var MIN_GAP   = 90;   /* minimum spacing between inner and outer rings */
    var MIN_INNER = 120;  /* floor so titles + 8 batch items fit comfortably */
    var safeUp     = orbitCyView - HEADER_PX;
    var safeDown   = window.innerHeight - orbitCyView - FOOTER_PX;
    var vertLimit  = Math.min(safeUp, safeDown);
    var horizLimit = window.innerWidth * 0.47;
    var maxRadius  = Math.min(vertLimit, horizLimit);
    var outerRadius = maxRadius;
    /* Inner = 62% of outer (visual ratio that reads as "concentric"),
       BUT clamped so outer - inner ≥ MIN_GAP. On small viewports the
       proportion would push them too close, so the gap clamp wins. */
    var innerRadius = Math.min(outerRadius * 0.62, outerRadius - MIN_GAP);
    innerRadius = Math.max(innerRadius, MIN_INNER);

    var allNodes  = Array.prototype.slice.call(netfield.querySelectorAll('.bios-netnode'));
    var batchNodes = allNodes.filter(function (n) { return n.classList.contains('is-batch-item'); });
    var restNodes  = allNodes.filter(function (n) { return !n.classList.contains('is-batch-item'); });
    if (batchNodes.length === 0 && restNodes.length === 0) return;

    /* Match the same deterministic sort used by applyCatalogOrbit /
       transitionCatalogOrbit so the spin starts from the canonical
       node order, not whatever the DOM happened to enumerate. */
    restNodes.sort(function (a, b) {
      return (parseInt(a.dataset.origIdx, 10) || 0) - (parseInt(b.dataset.origIdx, 10) || 0);
    });
    batchNodes.sort(function (a, b) {
      return (parseInt(a.dataset.origIdx, 10) || 0) - (parseInt(b.dataset.origIdx, 10) || 0);
    });

    var batchStartAngle = Math.PI / Math.max(batchNodes.length, 1);

    /* Disable left/top CSS transitions during the spin so the per-frame
       writes don't fight against tween animation. We stash the previous
       transition string per-node and restore it afterwards so the next
       pagination transition still has its slide easing. */
    allNodes.forEach(function (n) {
      n.dataset._spinOrigTrans = n.style.transition || '';
      n.style.transition = 'none';
    });

    _spinning = true;
    var startTime = performance.now();
    var DURATION = 6000 + Math.random() * 2200;       /* 6.0–8.2s total */
    /* Inner ring total rotation: 0.7–1.1 turns (a bit more than half,
       so it visibly cycles). Outer ring: 0.5–0.8 turns, OPPOSITE
       direction. Direction sign randomized per call. */
    var innerDir = Math.random() < 0.5 ? 1 : -1;
    var INNER_TOTAL = Math.PI * (1.4 + Math.random() * 0.8) * innerDir;
    var OUTER_TOTAL = Math.PI * (1.0 + Math.random() * 0.6) * (-innerDir);

    function tick(now) {
      var t = Math.min(1, (now - startTime) / DURATION);
      /* Cubic ease-in-out: starts and ends at rest, peaks in middle. */
      var eased = t < 0.5
        ? 4 * t * t * t
        : 1 - Math.pow(-2 * t + 2, 3) / 2;
      var innerOff = INNER_TOTAL * eased;
      var outerOff = OUTER_TOTAL * eased;

      batchNodes.forEach(function (node, i) {
        var nodeSize = parseFloat(node.style.width) || 168;
        var halfNS   = nodeSize / 2;
        var angle    = (i / batchNodes.length) * 2 * Math.PI - Math.PI / 2 + batchStartAngle + innerOff;
        node.style.left = (localCx + Math.cos(angle) * innerRadius - halfNS) + 'px';
        node.style.top  = (localCy + Math.sin(angle) * innerRadius - halfNS) + 'px';
      });
      restNodes.forEach(function (node, i) {
        var nodeSize = parseFloat(node.style.width) || 168;
        var halfNS   = nodeSize / 2;
        var angle    = (i / restNodes.length) * 2 * Math.PI - Math.PI / 2 + outerOff;
        node.style.left = (localCx + Math.cos(angle) * outerRadius - halfNS) + 'px';
        node.style.top  = (localCy + Math.sin(angle) * outerRadius - halfNS) + 'px';
      });

      if (t < 1) {
        _spinRafId = requestAnimationFrame(tick);
      } else {
        /* Restore transitions so future pagination slides + hover
           tweens animate normally again. */
        allNodes.forEach(function (n) {
          if (n.dataset._spinOrigTrans != null) {
            n.style.transition = n.dataset._spinOrigTrans;
            delete n.dataset._spinOrigTrans;
          }
        });
        _spinning = false;
        _spinRafId = null;
      }
    }
    _spinRafId = requestAnimationFrame(tick);
  }

  function scheduleNextSpin() {
    if (_spinTimeout) clearTimeout(_spinTimeout);
    /* Random gap 18–48s. Honors reduced-motion (no schedule at all). */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    var delay = 18000 + Math.random() * 30000;
    _spinTimeout = setTimeout(function () {
      if (drum && drum.classList.contains('is-catalog-orbit-mode') && !_spinning) {
        spinOnce();
      }
      scheduleNextSpin();
    }, delay);
  }
  /* Expose for debug. */
  window._biosOrbitSpin = spinOnce;

  /* Public entry point for batch pagination. Wheel handler below calls
     this with currentPage + direction. Updates batch tagging, re-emits
     the orbit (smooth transition variant — outer ring stays visually
     anchored, only swapped items glide between rings), and scrolls the
     centered #bios-list back to the top so the new batch reads from
     row 01 again. */
  function setBatchPage(pageNum) {
    if (!drum || !drum.classList.contains('is-catalog-orbit-mode')) return;
    /* Cancel any in-progress idle spin — its position writes would
       fight the pagination slide. */
    cancelSpin();
    /* Pause idle drift too — drift writes per-frame transform, the
       slide animates transform via CSS transition, the two would
       fight. Drift restarts a beat after the slide completes. */
    stopIdleDrift();
    /* Clear any active preview-source state + restore ASCII on the
       currently-hovered node BEFORE pagination. Without this, the
       decoded-empty ASCII lingers when that node moves from the
       inner ring into the outer ring on the new page. */
    if (typeof window._biosClearPreviewSource === 'function') {
      window._biosClearPreviewSource();
    }
    var items = document.querySelectorAll('#bios-list .bios-item');
    var totalPages = Math.max(1, Math.ceil(items.length / BATCH_SIZE));
    pageNum = Math.max(0, Math.min(totalPages - 1, pageNum));
    if (pageNum === _currentBatchPage) return;
    var changed = tagBatchForPage(pageNum);
    if (!changed) return;
    _currentBatchPage = pageNum;
    /* Scroll-page SFX — uses swap.wav (user-uploaded for this exact
       purpose) at 0.40 volume. Fires at the START of the page
       transition so the audio anchors the user's scroll intent (per
       the audio-causality principle: feedback should follow input
       within ~50ms). The 600ms cooldown in the wheel/keyboard handlers
       (lines 1688, 1705) prevents audio stacking on rapid scroll. */
    try {
      var _pageSfx = new Audio('https://cdn.shopify.com/s/files/1/0762/5726/3866/files/swap.wav?v=1779653575');
      _pageSfx.volume = 0.28;   /* dropped from 0.40 per "quieter" pass */
      var _psp = _pageSfx.play();
      if (_psp && typeof _psp.catch === 'function') _psp.catch(function () {});
    } catch (_) {}
    transitionCatalogOrbit();
    /* Reset list scroll so new batch starts from the top of the
       centred 12-item list. */
    var listEl = document.getElementById('bios-list');
    if (listEl) listEl.scrollTop = 0;
    /* Clear both the preview pane and the left info panel — the
       previously-hovered item may no longer be in the visible batch,
       so clearing reads as honest. */
    if (typeof window._biosClearHoverInfo === 'function') {
      window._biosClearHoverInfo();
    } else {
      var preview = document.getElementById('bios-catalog-preview');
      if (preview) preview.classList.remove('is-visible', 'is-swapping');
    }
    /* Restart idle drift after the slide animation completes (~0.6s
     slide + 0.4s safety = 1000ms). */
    setTimeout(startIdleDrift, 1000);
  }
  /* Expose for keyboard nav / debugging. */
  window._biosCatalogSetPage = setBatchPage;
  window._biosCatalogNextPage = function () { setBatchPage(_currentBatchPage + 1); };
  window._biosCatalogPrevPage = function () { setBatchPage(_currentBatchPage - 1); };

  function setupCatalogOrbit() {
    if (isTouchDevice || !drum || !netfield) return;
    /* Don't activate over designer mode — that owns the same center
       slot via .is-designer-mode. */
    if (drum.classList.contains('is-designer-mode')) return;
    /* Wait until netnodes match the .bios-item count before tagging,
       not just "nodes > 0". Earlier we'd proceed with a partial set
       which left the inner ring with fewer than BATCH_SIZE items
       (the missing netnodes hadn't been built yet by bios-netgraph).
       Wait for full parity, with a cap so we don't loop forever on
       genuinely-asymmetric catalogs (e.g., when a few products fail
       to render a netnode for some reason). */
    var items = document.querySelectorAll('#bios-list .bios-item');
    var nodes = netfield.querySelectorAll('.bios-netnode');
    var ready = nodes.length >= items.length || nodes.length >= BATCH_SIZE * 2;
    if (!ready && (setupCatalogOrbit._retries || 0) < 20) {
      setupCatalogOrbit._retries = (setupCatalogOrbit._retries || 0) + 1;
      setTimeout(setupCatalogOrbit, 200);
      return;
    }
    tagBatchItemsAndNodes();
    drum.classList.add('is-catalog-orbit-mode');
    /* Clear any inline transform on #bios-list set by an earlier
       setDrum() call (the initial centre-lock runs at page load
       before orbit mode activates and writes `translateY(56px)` as
       inline style). That inline style would override the CSS
       `translateX(-50%)` even with !important on the cascade, so
       wiping it here is the most robust fix. */
    var listEl = document.getElementById('bios-list');
    if (listEl) {
      listEl.style.transform = '';
      listEl.style.transition = '';
    }
    /* Also clear the inline `style.display='none'` that bios-main.js's
       renderPage(0) writes onto every item outside the first PAGE_SIZE
       (=4) window at boot. Without this, items 4-49 stay invisible in
       catalog-orbit mode no matter what class they carry, which broke
       pagination (no titles on page 1+). Clearing display="" lets the
       cascade rule `.bios-item:not(.is-batch-item){display:none}` take
       over so only NON-batch items hide. */
    var allItems = document.querySelectorAll('#bios-list .bios-item');
    allItems.forEach(function (it) { it.style.display = ''; });
    applyCatalogOrbit();
    _catalogOrbitInited = true;
    /* Idle counter-rotation spinner is gated off for now — function +
       scheduler remain in the file for future re-enable. Call
       scheduleNextSpin() here to bring it back. */
    /* scheduleNextSpin(); */
    /* Start the per-item idle drift loop so outer-ring nodes breathe
       slightly. Cheap RAF, only touches transform. Starts after a
       short delay so the chain-emerge animation lands cleanly first. */
    setTimeout(startIdleDrift, 1400);
    /* Defensive: re-tag once more after a beat in case any straggler
       netnodes finished building between our setup and the user's
       first interaction. tagBatchForPage is idempotent — if nothing
       changed, this is a cheap no-op. */
    setTimeout(function () {
      var nodesNow = netfield.querySelectorAll('.bios-netnode');
      var itemsNow = document.querySelectorAll('#bios-list .bios-item');
      if (nodesNow.length > nodes.length || nodesNow.length < itemsNow.length) {
        tagBatchForPage(_currentBatchPage);
        applyCatalogOrbit();
      }
    }, 500);
  }

  function teardownCatalogOrbit() {
    if (!drum) return;
    /* Stop the idle spin + idle drift so they don't keep firing
       inert RAF / timers after the user has left catalog-orbit mode
       (entered designer or navigated away). */
    cancelSpin();
    stopIdleDrift();
    if (_spinTimeout) { clearTimeout(_spinTimeout); _spinTimeout = null; }
    drum.classList.remove('is-catalog-orbit-mode');
    exitDesignerOrbit();
  }

  /* Wire hover-preview ONCE — handlers stay attached for the session. */
  (function wireCatalogPreview() {
    if (isTouchDevice) return;
    var preview = document.getElementById('bios-catalog-preview');
    if (!preview) return;
    var listEl = document.getElementById('bios-list');
    if (!listEl) return;
    /* Left-side info panel — printed-text mirror of the right preview.
       Populated from the same item's dataset so both surfaces always
       show the same product. Lookups are cached on first hover so
       we don't query the DOM on every mousemove. */
    var info       = document.getElementById('bios-catalog-info');
    var infoTitle  = document.getElementById('bios-catalog-info-title');
    var infoPrice  = document.getElementById('bios-catalog-info-price');
    var infoVendor = document.getElementById('bios-catalog-info-vendor');
    var infoStatus = document.getElementById('bios-catalog-info-status');
    var infoStock  = document.getElementById('bios-catalog-info-stock');
    var infoSku    = document.getElementById('bios-catalog-info-sku');
    var infoDesc   = document.getElementById('bios-catalog-info-desc');

    /* ── Text-glitch helper ──────────────────────────────────────────
       Mirrors the character-cycling decryption used by the netnode
       ASCII layer (bios-netgraph's decodeStart). Cycles each character
       through hex / binary / symbol noise then settles into the final
       string by reducing scramble probability via a cosine wave (1→0).
       Used to glitch-swap each field in the left info panel when the
       user hovers from one product title to another. Idempotent — if
       a glitch is already running on the element, it gets cancelled
       before the new one starts so back-to-back swaps don't pile up. */
    var DECODE_GLITCH = '0123456789ABCDEF#@░▒▓?!ア▄▀%&'.split('');
    function glitchText(el, finalText, duration, onComplete) {
      if (!el) return;
      if (el._glitchRaf) {
        cancelAnimationFrame(el._glitchRaf);
        el._glitchRaf = null;
      }
      var reducedMotion = window.matchMedia &&
                          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var finalStr = String(finalText == null ? '' : finalText);
      if (reducedMotion) {
        el.textContent = finalStr;
        if (typeof onComplete === 'function') onComplete();
        return;
      }
      duration = duration || 380;
      var startTime = performance.now();
      function tick(now) {
        var t = Math.min(1, (now - startTime) / duration);
        if (t >= 1) {
          el.textContent = finalStr;
          el._glitchRaf = null;
          if (typeof onComplete === 'function') onComplete();
          return;
        }
        /* Cosine scramble probability — high at the start, settles
           toward 0 as the glitch resolves. */
        var scrambleP = (Math.cos(t * Math.PI) + 1) * 0.5;
        var chars = finalStr.split('');
        for (var i = 0; i < chars.length; i++) {
          var c = chars[i];
          /* Preserve whitespace + separators so layout doesn't jump
             around mid-glitch. */
          if (c === ' ' || c === '\n' || c === ':' || c === '-' || c === '·' || c === '─') continue;
          if (Math.random() < scrambleP) {
            chars[i] = DECODE_GLITCH[Math.floor(Math.random() * DECODE_GLITCH.length)];
          }
        }
        el.textContent = chars.join('');
        el._glitchRaf = requestAnimationFrame(tick);
      }
      el._glitchRaf = requestAnimationFrame(tick);
    }
    /* Expose for potential cross-file use. */
    window._biosGlitchText = glitchText;
    /* Hover-in / hover-out behavior:
       - TITLE: glitches IN on enter (character scramble settling into
         the product name) and glitches OUT on leave (scramble back to
         noise then clear). Uses the same DECODE_GLITCH character set
         as the netnode ASCII decode so the effect reads consistently
         across both surfaces.
       - OTHER FIELDS (price, vendor, status, stock, sku, desc): load
         in with a downward stagger — each line appears at a small
         delay below the previous, mimicking a terminal BIOS printout
         line-by-line. No glitch on these; just a quick fade+slide-in. */
    function setInfo(item) {
      if (!info) return;
      if (!item) {
        /* Hover-out: glitch the title out (scramble while fading), then
           hide the panel. Other fields just fade with the panel. */
        if (infoTitle && infoTitle.textContent) {
          /* Reverse glitch: scramble back into noise. We glitch toward
             an empty string with a quick duration so the title visibly
             dissolves before the panel clears. */
          glitchText(infoTitle, '', 240);
        }
        info.classList.remove('is-visible');
        return;
      }
      var name   = item.dataset.name || '';
      var vendor = item.dataset.vendor || '—';
      var price  = item.dataset.price || '—';
      var soldOut = item.dataset.soldOut === 'true';
      var inv    = parseInt(item.dataset.inventory, 10);
      var sku    = item.dataset.sku || '—';
      var rawDesc = (item.dataset.description || '').replace(/\s+/g, ' ').trim();
      var statusTxt = soldOut ? '[ OUT OF STOCK ]' : 'AVAILABLE';
      var stockTxt  = soldOut
        ? '0'
        : (!isNaN(inv) && inv >= 0 ? String(inv) : 'IN STOCK');
      var descTxt   = rawDesc || '— no description on file —';

      /* Title — glitch IN to the new name. onComplete restores the
         vendor-prefix dim HTML so the brand-prefix dim shows once the
         glitch resolves. (During the glitch we only manipulate
         textContent — the dim span re-appears at the end.) */
      if (infoTitle) {
        var dimHtml = (typeof window._biosDimVendorPrefix === 'function')
          ? window._biosDimVendorPrefix(name, vendor === '—' ? '' : vendor)
          : null;
        glitchText(infoTitle, name, 480, function () {
          if (dimHtml) infoTitle.innerHTML = dimHtml;
        });
      }
      /* All non-title fields set instantly via textContent — the
         visual reveal is handled by the CSS staggered animation
         keyed to the .is-loading class added on every fresh setInfo
         call. */
      if (infoPrice)  infoPrice.textContent  = price;
      if (infoVendor) infoVendor.textContent = vendor;
      if (infoSku)    infoSku.textContent    = sku;
      if (infoStock)  infoStock.textContent  = stockTxt;
      if (infoStatus) {
        infoStatus.textContent = statusTxt;
        infoStatus.className   = 'bios-catalog-info-val ' + (soldOut ? 'is-err' : 'is-ok');
      }
      if (infoDesc)   infoDesc.textContent   = descTxt;

      /* Re-trigger the downward cascade animation: remove + re-add
         the .is-loading class, force a reflow between, so the
         keyframe starts from frame 0 each time. */
      info.classList.remove('is-loading');
      void info.offsetWidth;     /* reflow */
      info.classList.add('is-loading', 'is-visible');
    }
    var _lastImg = '';
    var _lastItem = null;
    var _swapTimer = null;
    var _marqueeTimer = null;
    var _marqueeNameEl = null;

    /* Stock-ticker marquee for truncated titles. After 200ms of
       continuous hover on a row whose title is ellipsis-truncated,
       start animating text-indent so the hidden remainder slides off
       the left edge linearly, then restarts at the beginning.

       Previous design (Spotify-style) eased the text from start →
       end-of-text → back to start with smooth holds at each extreme.
       The user wanted a one-direction ticker pattern — keep going
       left, then jump back to start — which is what the new keyframes
       in base.css do. The shift here is the FULL text width plus a
       small padding so the text fully exits the viewport before the
       CSS animation loop snaps back to 0. */
    function startMarqueeForItem(item) {
      if (!item) return;
      var nameEl = item.querySelector('.bios-item-name');
      if (!nameEl) return;
      requestAnimationFrame(function () {
        var overflow = nameEl.scrollWidth - nameEl.clientWidth;
        if (overflow <= 4) return;        /* not truncated → skip */
        /* Ticker shift = full text width + 20px breathing space so the
           text disappears entirely before the loop restarts. */
        var tickerShift = nameEl.scrollWidth + 20;
        nameEl.style.setProperty('--marquee-shift', '-' + tickerShift + 'px');
        nameEl.classList.add('is-marquee');
        _marqueeNameEl = nameEl;
      });
    }
    function stopMarquee() {
      if (_marqueeTimer) {
        clearTimeout(_marqueeTimer);
        _marqueeTimer = null;
      }
      if (_marqueeNameEl) {
        _marqueeNameEl.classList.remove('is-marquee');
        _marqueeNameEl.style.removeProperty('--marquee-shift');
        _marqueeNameEl = null;
      }
    }

    /* Sync the corresponding ring node's "preview source" state with
       whichever batch title is currently hovered. The title hover
       decodes that node (ASCII fades, image reveals) AND populates
       the right preview pane — both surfaces light up together so
       the visual pair reads as one composed unit. */
    function setPreviewSource(item) {
      if (!netfield) return;
      /* Clear any previously-active preview source AND restore its
         ASCII via the netgraph's decodeStop. Without this, when a
         page change moves the previously-decoded node into the outer
         ring, the empty-ASCII state lingers — looks like a "ghost
         decoded" node in the outer ring. Restoring it on every
         clear guarantees the outer ring is always fully ASCII'd. */
      var prev = netfield.querySelectorAll('.bios-netnode.is-preview-source');
      prev.forEach(function (n) {
        n.classList.remove('is-preview-source');
        if (typeof window._biosNetnodeRestore === 'function') {
          window._biosNetnodeRestore(n);
        }
      });
      if (!item) return;
      var idx = item.dataset.idx;
      if (idx == null) return;
      var node = netfield.querySelector('.bios-netnode[data-orig-idx="' + idx + '"]');
      if (node) {
        node.classList.add('is-preview-source');
        /* Run the same character-cycling decrypt animation the user
           gets hovering a netnode directly. Replaces the previous
           plain opacity fade so the title-hover state reads as a
           real decoding event. */
        if (typeof window._biosNetnodeDecode === 'function') {
          window._biosNetnodeDecode(node);
        }
      }
    }
    /* Expose for setBatchPage to call when paginating — ensures any
       lingering preview-source state is wiped + ASCII restored before
       the orbit transitions. */
    window._biosClearPreviewSource = function () { setPreviewSource(null); };

    /* Delegate to avoid attaching to each item; preview reacts to any
       .bios-item hover, but ignores items that aren't batch items
       since only those are visible in catalog-orbit mode anyway. */
    listEl.addEventListener('mouseover', function (e) {
      var item = e.target.closest('.bios-item');
      if (!item || !item.classList.contains('is-batch-item')) return;
      if (!drum.classList.contains('is-catalog-orbit-mode')) return;
      var img = item.dataset.img;
      if (!img) return;
      preview.style.backgroundImage = 'url(' + img + ')';
      preview.classList.add('is-visible');
      /* Preview-pane is-swapping zoom pulse intentionally removed —
         the new "hover signal" is the title text itself glitch-decoding
         from DECODE_GLITCH noise into the product name (handled below
         under `if (item !== _lastItem)`). The image swap on the preview
         pane is silent now; the title's character-cycle does the
         visual work that the scale pulse used to do. */
      _lastImg = img;
      /* Update ring-side highlight + left info panel + marquee
         only when the item actually changed — avoids thrashing on
         every mousemove. */
      if (item !== _lastItem) {
        /* Product-title hover SFX — fires once per title-change
           (i.e. moving the cursor from one product to another OR
           landing on the first product). Volume 0.22 — between the
           generic hover (0.18) and the default click (0.28).
           Universal hover handler in theme.liquid is set to skip
           .bios-item / .bios-netnode so this is the sole cue here. */
        try {
          var _prodSfx = new Audio('https://cdn.shopify.com/s/files/1/0762/5726/3866/files/product.wav?v=1779658804');
          _prodSfx.volume = 0.22;
          var _psp2 = _prodSfx.play();
          if (_psp2 && typeof _psp2.catch === 'function') _psp2.catch(function () {});
        } catch (_) {}
        setPreviewSource(item);
        setInfo(item);
        /* ── Title-text glitch on item change ──────────────────────
           Runs the same DECODE_GLITCH character-cycle that the left
           info panel title uses, but in-place on the hovered row's
           own .bios-item-name. Reads as "the system is decoding which
           product you're pointing at" — a stronger, text-native signal
           than the previous preview-pane zoom pulse.

           Restoration: vendor-prefix dim is innerHTML-driven (a
           <span class="vendor-dim">...</span> wraps the prefix); the
           glitch operates on textContent, so the dim span is lost
           mid-glitch and re-applied via _biosDimVendorPrefix at the
           onComplete callback.

           Marquee dwell bumped from 200ms → 540ms so the glitch
           (480ms) finishes before the marquee starts panning; otherwise
           text-indent animates a half-decoded string and reads as
           jitter rather than reveal. */
        /* Title-text hover glitch removed per design call — the previous
           DECODE_GLITCH scramble on every title-change felt too noisy
           with the universal click sound already firing on each hover-
           tap. Title now just sits in its rendered (vendor-dimmed) state
           and the marquee handles any overflow reveal.

           Marquee dwell back down to 200ms since there's no glitch
           animation to wait out. */
        stopMarquee();
        /* 50ms — near-instant. Earlier 200ms felt unresponsive and the
           user reported the marquee not firing at all. Dropping the
           dwell makes it kick in basically as soon as the hover
           registers as a stable item-change event. */
        _marqueeTimer = setTimeout(function () {
          startMarqueeForItem(item);
        }, 50);
        _lastItem = item;
      }
    });
    listEl.addEventListener('mouseleave', function () {
      preview.classList.remove('is-visible');
      preview.classList.remove('is-swapping');
      setPreviewSource(null);
      setInfo(null);
      stopMarquee();
      _lastImg = '';
      _lastItem = null;
    });
    /* Expose so pagination can clear all hover surfaces in one shot. */
    window._biosClearHoverInfo = function () {
      preview.classList.remove('is-visible', 'is-swapping');
      setInfo(null);
      stopMarquee();
      _lastImg = '';
      _lastItem = null;
    };
  })();

  /* Set up on portal dismissal (catalog reveals) and on every flip back
     to NEW ARRIVALS. */
  document.addEventListener('bios:portal-done', function () {
    /* Apply catalog-orbit-mode CSS IMMEDIATELY before the setup retry
       loop kicks in. Without this, the catalog flashes its DEFAULT
       layout (left-column list + filter bar + search) for ~300ms
       between portal dismissal and setupCatalogOrbit completing —
       which the user perceives as "a previous version of the nav
       flashing for a moment". The early class flips on the
       hide/centre CSS so the catalog never renders in non-orbit mode. */
    /* Skip on touch — orbit mode is desktop-only. Mobile sees the
       default catalog layout (no orbit ring), so applying the class
       would just hide everything via the
       .bios-item:not(.is-batch-item){display:none} rule. */
    if (!isTouchDevice && drum && !drum.classList.contains('is-designer-mode')) {
      drum.classList.add('is-catalog-orbit-mode');
      var listEl = document.getElementById('bios-list');
      if (listEl) {
        listEl.style.transform = '';
        listEl.style.transition = '';
      }
      var allItems = document.querySelectorAll('#bios-list .bios-item');
      allItems.forEach(function (it) { it.style.display = ''; });
    }
    /* Small delay so bios-netgraph has time to finish building
       netnodes before setupCatalogOrbit tries to position them.
       The flash mitigation comes from the synchronous class-add
       above + the inline script in main-content.liquid (which
       handles logo-back-to-home), not from running setup instantly.
       Running setup instantly competes with the wordmark typewriter
       + 3D scene boot, which the user reported as landing-page lag. */
    setTimeout(setupCatalogOrbit, 250);
  });
  /* Deep-link fallback: if the user lands on the catalog with portal
     already dismissed (sessionStorage hides it — header-logo click
     back to home, refresh on /, etc.), set up after a short delay.
     The inline script in main-content.liquid has already added
     .is-catalog-orbit-mode synchronously on DOM parse so the CSS
     layout is correct from the first frame — no flash. This
     setTimeout lets bios-netgraph.js finish building netnodes
     before we try to position them, which avoids the retry loop
     thrashing alongside the wordmark typewriter + 3D scene boot
     (the cause of the recent landing-page lag report). */
  if (sessionStorage.getItem('bios_portal_choice')) {
    setTimeout(setupCatalogOrbit, 300);
  }

  /* Hook flipTo: when entering DESIGNERS, teardown catalog orbit so the
     center slot is clean for the brand list. When exiting back to NEW
     ARRIVALS, re-setup. We piggyback on the existing tab click listeners
     by re-running setup/teardown after their async glitch swap. */
  if (tabDesigners) {
    tabDesigners.addEventListener('click', function () {
      setTimeout(teardownCatalogOrbit, 220);
    });
  }
  if (tabProducts) {
    tabProducts.addEventListener('click', function () {
      setTimeout(setupCatalogOrbit, 220);
    });
  }

  /* ── Wheel-driven batch pagination inside catalog-orbit mode ─────────
     Accumulate wheel.deltaY until it crosses a threshold, then advance
     the batch page. Threshold + cooldown protect against scroll-wheel
     burst (a single trackpad inertia event can fire deltaY > 50 many
     times in 100ms — without cooldown the user would skip 3-4 pages
     on a single flick). Bails everywhere except catalog-orbit so it
     never collides with regular drum scroll. */
  (function wireBatchWheel() {
    if (isTouchDevice) return;
    var WHEEL_THRESHOLD = 80;     /* deltaY total to trigger page change */
    var COOLDOWN_MS     = 600;    /* min ms between page changes */
    var _wheelAccum     = 0;
    var _lastChangeAt   = 0;

    document.addEventListener('wheel', function (e) {
      if (!drum || !drum.classList.contains('is-catalog-orbit-mode')) return;
      e.preventDefault();
      var now = Date.now();
      /* Cooldown: ignore wheel events for COOLDOWN_MS after a page change
         so trackpad inertia bursts don't blow past multiple pages. */
      if (now - _lastChangeAt < COOLDOWN_MS) {
        _wheelAccum = 0;
        return;
      }
      _wheelAccum += e.deltaY;
      if (Math.abs(_wheelAccum) > WHEEL_THRESHOLD) {
        var dir = _wheelAccum > 0 ? 1 : -1;
        setBatchPage(_currentBatchPage + dir);
        _wheelAccum = 0;
        _lastChangeAt = now;
      }
    }, { passive: false });

    /* Keyboard arrow nav as a peer to scroll — same cooldown semantics. */
    document.addEventListener('keydown', function (e) {
      if (!drum || !drum.classList.contains('is-catalog-orbit-mode')) return;
      var now = Date.now();
      if (now - _lastChangeAt < COOLDOWN_MS) return;
      if (e.key === 'ArrowDown' || e.key === 'PageDown') {
        e.preventDefault();
        setBatchPage(_currentBatchPage + 1);
        _lastChangeAt = now;
      } else if (e.key === 'ArrowUp' || e.key === 'PageUp') {
        e.preventDefault();
        setBatchPage(_currentBatchPage - 1);
        _lastChangeAt = now;
      }
    });
  })();

  /* Public hook used by bios-netgraph.js resize handler — re-emits whichever
     orbit is currently active so the rings re-centre on the new viewport
     instead of getting clobbered by the default layoutNodes() column flow. */
  window._biosReapplyOrbit = function () {
    if (!drum) return;
    if (drum.classList.contains('is-catalog-orbit-mode')) {
      applyCatalogOrbit();
    } else if (drum.classList.contains('is-designer-mode')) {
      applyAllItemsOrbit();
    }
  };
})();
